// NodeTile.jsx

import React from 'react';

// CSS
import './NodeTile.css';

// Components
import NodeView from 'nodetypes/node/view/NodeView';

/**
 * NodeTile
 *
 * @returns {ReactNode} The rendered component.
 */
const NodeTile = ({ node }) => {

  if (!node) return null;
  const cover =
    typeof node?.coverUrl === 'string' && node.coverUrl.trim().length > 0
      ? node.coverUrl
      : null;

  // ----- RENDER ----- //

  return (

    <div className="node-tile-container">
      {/* TITLE */}
      <div className="node-tile-title">
        {node?.title}
      </div>

      {/* BACKGROUND */}
      <div className="node-tile-background">

        {/* BGIMAGE */}
        {cover ? (
          <img
            className="node-tile-bgimage"
            src={cover}
            alt=""
            aria-hidden="true"
            draggable="false"
            loading="lazy"
          />
        ) : (
          <>
            <NodeView
              key={node.key}
              node={node}
              height="100%"
              showInfo={false}
            />
          </>
        )}
      </div>
    </div>
  );
};

// Dev Tools
NodeTile.displayName = 'NodeTile';

export default NodeTile;
